// extracted by mini-css-extract-plugin
var _1 = "w74oucCHjd6qFXqInBnO";
var _2 = "dsDmo6DPNZzH6wkjJnVg";
var _3 = "BQ4fO_P8cZUtNynvju1Q";
var _4 = "uJJeyw2SVu5AioDC8jyc";
var _5 = "kF4RnGo4E6MCCnE35ck5";
var _6 = "uVQmNKdLwVm3iY5WSaEF";
var _7 = "_2AIxaFARTTKcG05YUQ0";
var _8 = "QC5eqL_N2Fs_J7rNce8a";
var _9 = "wfAW3VVpWeeJLXjSLQ5O";
export { _1 as "container", _2 as "controls", _3 as "duration", _4 as "header", _5 as "metadata", _6 as "playButton", _7 as "sliderContainer", _8 as "time", _9 as "title" }
